<mat-tab-group
	#tabs
	[dynamicHeight]="false"
	[selectedIndex]="0"
	test-id="sga-login-notice-tab-group"
	data-test-id="sga-login-notice-tab-group"
	[@.disabled]="true"
>
	<mat-tab test-id="login-info">
		<ng-template mat-tab-label>
			<span [innerHTML]="'sga-login-alert.login-tab' | translate"></span>
		</ng-template>
		<ng-template matTabContent>
			<mat-icon class="ico-profile"></mat-icon>
			<div [innerHTML]="data?.loginMessage"></div>
			<div
				*ngIf="covidMeasuresEnabled && data?.sessionLimitsMessage as sessionLimitsMessage"
				class="obg-m-sga-login-notice-session-limit-container"
			>
				<span>{{ sessionLimitsMessage.text }}</span>
				<div>
					<span>
						{{ sessionLimitsMessage.dailySessionLimit }}
						{{ "multi-session-limit.daily.input-suffix" | translate | lowercase }}</span
					>,
					<span>
						{{ sessionLimitsMessage.weeklySessionLimit }}
						{{ "multi-session-limit.weekly.input-suffix" | translate | lowercase }}</span
					>,
					<span>
						{{ sessionLimitsMessage.monthlySessionLimit }}
						{{ "multi-session-limit.monthly.input-suffix" | translate | lowercase }}</span
					>
				</div>
			</div>
			<ng-container *ngTemplateOutlet="covidDepositLimitInfo"></ng-container>
			<div
				class="obg-m-sga-login-notice-gambling-safe"
				[innerHTML]="'sga-login-alert.keep-gambling-safe' | translate"
			></div>
		</ng-template>
	</mat-tab>
	<mat-tab test-id="wins-losses-tab">
		<ng-template mat-tab-label>
			<span [innerHTML]="'sga-login-alert.wins-losses-tab' | translate"></span>
		</ng-template>
		<ng-template matTabContent>
			<mat-icon class="ico-currency"></mat-icon>
			<div [innerHTML]="data?.netWinningMessage" obgSensitiveData></div>
		</ng-template>
	</mat-tab>
	<mat-tab test-id="deposit-limits-tab">
		<ng-template mat-tab-label>
			<span [innerHTML]="'sga-login-alert.deposit-limits-tab' | translate"></span>
		</ng-template>
		<ng-template matTabContent>
			<mat-icon class="ico-deposit-limit-shield"></mat-icon>
			<div
				(click)="closeOnClickAnchor($event.target.nodeName)"
				[innerHTML]="data?.depositLimitsMessage"
				obgSensitiveData
			></div>
			<ng-container *ngTemplateOutlet="covidDepositLimitInfo"></ng-container>
		</ng-template>
	</mat-tab>
</mat-tab-group>

<ng-template #covidDepositLimitInfo>
	<div
		*ngIf="covidMeasuresEnabled && data?.covid19limitMessage"
		class="obg-m-sga-login-notice-deposit-limit-container"
	>
		<span class="ico-information-circle"></span>
		<p>{{ data?.covid19limitMessage }}</p>
	</div>
</ng-template>
